import styled from 'styled-components';

import { hexToRgba } from '~/common/utils/hex-to-rgba';
import { SPACING } from '~/common/constants/spacing';
import { RADIUS } from '~/common/constants/border-radius';

export const BadgeContainer = styled.div<{
  color: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ color }) => hexToRgba(color, 0.25)};
  padding: ${SPACING._6};
  border-radius: ${RADIUS._12};
`;
